import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

export function Confirm({ open, title, onCancel, onConfirm, label = "Confirmer" }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <DialogContent className="w-[92vw] max-w-sm rounded-2xl bg-white" data-testid="confirm-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl leading-snug">{title}</DialogTitle></DialogHeader>
        <div className="mt-2 grid gap-2">
          <button className="btn-primary !min-h-[56px] text-lg uppercase" onClick={onConfirm} data-testid="confirm-ok-btn">{label}</button>
          <button className="btn-ghost" onClick={onCancel} data-testid="confirm-cancel-btn">Annuler</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
